<template>
  <div
    class="px-24 py-16"
  >
    <strong>
      {{ $t('delete-account.info-step.heading') }}
    </strong>
    <div class="p-info-step">
      {{ message }}
    </div>
  </div>
</template>

<script>

export default {
  name: 'InfoStep',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
};
</script>

<style lang="scss" scoped>
  .p-info-step {
    white-space: pre-line;
  }
</style>
